import TextBox from "../../../../../../../common/components/molecule/TextBox/TextBox"

export interface StreetLightNumberViewProps {
    number?: string
}

export default function StreetLightNumberView({number}: StreetLightNumberViewProps) {
  return (
    <TextBox variant='dark' content={[{
        title: 'Numéro',
        text: number
    }]}/>
  )
}
